<template>
  <div class="dialog-op-role-editor-wrapper">
    <el-dialog
      :title="mode === 'create' ? '添加角色' : '修改角色'"
      width="70%"
      :visible="visible"
      @open="onDialogOpen"
      @close="onDialogClose">

      <el-form label-position="left" ref="form" :rules="formRule" :model="form">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="remark">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="角色权限列表"></el-form-item>
        <div class="res-list-wrapper">
          <div v-for="resCate in resCateList" :key="resCate.resource_category_id">
            <div class="res-cate-title">
              <el-checkbox
                @change="onResCateChange(resCate, $event)">
                <span style="font-weight: bold; margin-left: .2rem">{{ resCate.name }}</span>
              </el-checkbox>
            </div>
            <div class="res-checkbox-list">
              <el-checkbox-group v-model="form.resourceIdList">
                <el-checkbox
                  :label="res.resource_id"
                  v-for="res in resCate.resource_list"
                  :key="res.resource_id"
                  size="mini">{{ res.name }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onSubmit">确定</el-button>
          <el-button @click="onCancel">取消</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogEditOpPermission',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    mode: {
      type: String,
      required: false
    },
    visible: {
      type: Boolean,
      required: true
    },
    resCateList: {
      type: Array,
      required: true
    },
    role: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      formRules: {
        name: [
          { required: true, message: '请输入权限的名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入权限的代号', trigger: 'blur' }
        ],
        resources: [
          { required: true, message: '请选择权限的资源', trigger: 'change' }
        ]
      },
      form: {
        name: '',
        resourceIdList: [],
        remark: ''
      },
      formRule: {
        name: [
          { required: true, message: '请输入角色的名称', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入角色的描述', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('acl', [
      'opResourceList'
    ])
  },
  methods: {
    ...mapActions('acl', [
      'updateOpPermission',
      'getOpResources'
    ]),

    onResCateChange (resCate, checked) {
      if (checked) {
        for (let res of resCate.resource_list) {
          const index = this.form.resourceIdList.indexOf(res.resource_id)
          if (index === -1) {
            this.form.resourceIdList.push(res.resource_id)
          }
        }
      } else {
        for (let res of resCate.resource_list) {
          const index = this.form.resourceIdList.indexOf(res.resource_id)
          if (index !== -1) {
            this.form.resourceIdList.splice(index, 1)
          }
        }
      }
    },

    onDialogOpen () {
      if (this.mode === 'update') {
        this.form.name = this.role.name
        this.form.remark = this.role.remark
        this.form.resourceIdList = []
        for (const resId of this.role.resource_id_list) {
          const index = this.form.resourceIdList.indexOf(resId)
          if (index === -1) {
            this.form.resourceIdList.push(resId)
          }
        }
      } else {
        this.form = {
          name: '',
          resourceIdList: [],
          remark: ''
        }
      }
    },
    onDialogClose () {
      this.$emit('change', false)
    },

    async onSubmit () {
      try {
        await this.$refs['form'].validate()
        this.$emit('submit', this.form)
        this.$emit('change', false)
      } catch (err) {
        console.log(err)
      }
    },
    onCancel () {
      this.$refs['form'].resetFields()
      this.form.resources = []
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-op-role-editor-wrapper {

  .res-list-wrapper {
    background-color: #f5f5f5;
    padding: 1rem;
    margin: 1rem 0;
    border-radius: 5px;

    .res-checkbox-list {
      padding: 1.2rem;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/op/acl/components/DialogOpRoleEditor.vue